import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedBlobField, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCities } from 'app/entities/city/city.reducer';
import { ActivityType } from 'app/shared/model/enumerations/activity-type.model';
import { createEntity, getEntity, reset, updateEntity } from './advertisment.reducer';

export const AdvertismentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const cities = useAppSelector(state => state.city.entities);
  const advertismentEntity = useAppSelector(state => state.advertisment.entity);
  const loading = useAppSelector(state => state.advertisment.loading);
  const updating = useAppSelector(state => state.advertisment.updating);
  const updateSuccess = useAppSelector(state => state.advertisment.updateSuccess);
  const activityTypeValues = Object.keys(ActivityType);

  const handleClose = () => {
    navigate(`/advertisment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCities({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    values.fromDate = convertDateTimeToServer(values.fromDate);
    values.toDate = convertDateTimeToServer(values.toDate);

    const entity = {
      ...advertismentEntity,
      ...values,
      city: cities.find(it => it.id.toString() === values.city?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          fromDate: displayDefaultDateTime(),
          toDate: displayDefaultDateTime(),
        }
      : {
          activityType: 'ADVENTURE',
          ...advertismentEntity,
          fromDate: convertDateTimeFromServer(advertismentEntity.fromDate),
          toDate: convertDateTimeFromServer(advertismentEntity.toDate),
          city: advertismentEntity?.city?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.advertisment.home.createOrEditLabel" data-cy="AdvertismentCreateUpdateHeading">
            <Translate contentKey="activitiesApp.advertisment.home.createOrEditLabel">Create or edit a Advertisment</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="advertisment-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.advertisment.fromDate')}
                id="advertisment-fromDate"
                name="fromDate"
                data-cy="fromDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.advertisment.toDate')}
                id="advertisment-toDate"
                name="toDate"
                data-cy="toDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.advertisment.active')}
                id="advertisment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('activitiesApp.advertisment.imageurl')}
                id="advertisment-imageurl"
                name="imageurl"
                data-cy="imageurl"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.advertisment.activityType')}
                id="advertisment-activityType"
                name="activityType"
                data-cy="activityType"
                type="select"
              >
                {activityTypeValues.map(activityType => (
                  <option value={activityType} key={activityType}>
                    {translate(`activitiesApp.ActivityType.${activityType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('activitiesApp.advertisment.description')}
                id="advertisment-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedBlobField
                label={translate('activitiesApp.advertisment.advertismentImage')}
                id="advertisment-advertismentImage"
                name="advertismentImage"
                data-cy="advertismentImage"
                isImage
                accept="image/*"
              />
              <ValidatedField
                id="advertisment-city"
                name="city"
                data-cy="city"
                label={translate('activitiesApp.advertisment.city')}
                type="select"
              >
                <option value="" key="0" />
                {cities
                  ? cities.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.cityName}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/advertisment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AdvertismentUpdate;
